// CRA loads .env.development for npm start and .env.production for builds.
const configuredURL = process.env.REACT_APP_API_URL;
if (!configuredURL) {
  throw new Error('Falta REACT_APP_API_URL en el entorno del Timer.');
}

export default configuredURL.replace(/\/+$/, '');



// WEBPACK FOOTER //
// ./src/config/api.js